import { useCallback, useMemo, useState, useEffect } from 'react';
import useGetAreEmailTypesAvailable from 'email-management-lib/EmailCreation/hooks/useGetAreEmailTypesAvailable';
import UIFormControl from 'UIComponents/form/UIFormControl';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import UILockBadge from 'UIComponents/badge/UILockBadge';
import HubspotBlogSelection from './HubspotBlogSelection';
import RSSFeedSelection from './RssFeedSelection';
import useBlogRSSFeedDataState from '../../hooks/useBlogRssFeedDataState';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function BlogRssFeedDataSelection() {
  const {
    openUpgradeModal
  } = useUpgradeModal('email-blog-rss-sends');
  const {
    setBlogID,
    setFrequency,
    setRssFeedUrl
  } = useBlogRSSFeedDataState();
  const [isHubspotBlogSelected, setIsHubspotBlogSelected] = useState(true);
  const areEmailTypesAvailable = useGetAreEmailTypesAvailable();
  const isRSSAvailable = useMemo(() => areEmailTypesAvailable(['RSS_EMAIL']), [areEmailTypesAvailable]);
  const onSelectedHubspotBlog = useCallback(() => {
    setIsHubspotBlogSelected(true);
  }, []);
  const onSelectRSSFeed = useCallback(() => {
    if (isRSSAvailable) {
      setIsHubspotBlogSelected(false);
    } else {
      openUpgradeModal();
    }
  }, [isRSSAvailable, openUpgradeModal]);
  useEffect(() => {
    if (isHubspotBlogSelected) {
      setRssFeedUrl(null);
    } else {
      setBlogID(null);
      setFrequency(null);
    }
  }, [isHubspotBlogSelected, setBlogID, setFrequency, setRssFeedUrl]);
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "blog-rss-feed-data-selection",
    children: [/*#__PURE__*/_jsx(UIFormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-management-creation.createEmailPanel.blogRSS.feedSource"
      }),
      children: /*#__PURE__*/_jsxs(UIToggleGroup, {
        name: "feedSource",
        children: [/*#__PURE__*/_jsx(UIRadioInput, {
          "data-test-id": "hubspot-blog-radio",
          name: "feedSource",
          checked: isHubspotBlogSelected,
          inline: true,
          size: "sm",
          onChange: onSelectedHubspotBlog,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "email-management-creation.createEmailPanel.blogRSS.hubspotBlogOption"
          })
        }), /*#__PURE__*/_jsxs(UIRadioInput, {
          "data-test-id": "rss-feed-radio",
          name: "feedSource",
          checked: !isHubspotBlogSelected,
          inline: true,
          size: "sm",
          onChange: onSelectRSSFeed,
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "email-management-creation.createEmailPanel.blogRSS.rssFeedOption"
          }), !isRSSAvailable && /*#__PURE__*/_jsx(UILockBadge, {})]
        })]
      })
    }), isHubspotBlogSelected && /*#__PURE__*/_jsx(HubspotBlogSelection, {}), !isHubspotBlogSelected && /*#__PURE__*/_jsx(RSSFeedSelection, {})]
  });
}